import { createFileRoute } from "@tanstack/react-router";
import { LegalPublicPage } from "@/components/legal/LegalPublicPage";
import { publicSitePath } from "@/lib/public-site";

export const Route = createFileRoute("/privacidad")({
  component: PrivacidadPage,
  head: () => ({
    meta: [{ title: "Política de Privacidad — tunegocio" }],
    links: [{ rel: "canonical", href: publicSitePath("/privacidad") }],
  }),
});

function PrivacidadPage() {
  return (
    <LegalPublicPage
      title="Política de Privacidad"
      type="privacy_policy"
    />
  );
}
